const BOARD_FIELDS = [
  'id', 'projectId', 'episodeId', 'segmentIndex', 'title', 'durationSeconds',
  'durationProfile', 'durationProvider', 'durationModel', 'timeRange',
  'location', 'weather', 'sourceText', 'storyMode', 'narrationText', 'shots',
  'spatial', 'assetRefs', 'seedancePrompt', 'lightingPrompt', 'videoUrl',
  'originalVideoUrl', 'thumbnailUrl', 'taskId', 'internalTaskId',
  'videoProvider', 'videoModel', 'videoResolution', 'videoRatio', 'status',
  'error', 'createdAt', 'updatedAt', 'completedAt', 'storyboardRuleId',
];

const stableValue = (value) => {
  if (Array.isArray(value)) return value.map(stableValue);
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.keys(value).sort().map((key) => [key, stableValue(value[key])]));
  }
  return value ?? null;
};

const snapshot = (segment) => BOARD_FIELDS.map((field) => stableValue(segment?.[field]));

export const matchesMiniStoryboardBoardSnapshot = (serverSegments, displayedSegments) => {
  if (!Array.isArray(serverSegments) || !Array.isArray(displayedSegments)) return false;
  if (serverSegments.length !== displayedSegments.length) return false;
  const byIndex = (a, b) => Number(a?.segmentIndex) - Number(b?.segmentIndex);
  const server = [...serverSegments].sort(byIndex).map(snapshot);
  const displayed = [...displayedSegments].sort(byIndex).map(snapshot);
  return JSON.stringify(server) === JSON.stringify(displayed);
};
